var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0019 0.985176C10.5119 0.495176 9.72189 0.495176 9.23189 0.985176L0.921895 9.29518C0.531895 9.68518 0.531895 10.3152 0.921895 10.7052L9.23189 19.0152C9.72189 19.5052 10.5119 19.5052 11.0019 19.0152C11.4919 18.5252 11.4919 17.7352 11.0019 17.2452L3.76189 9.99518L11.0119 2.74518C11.4919 2.26518 11.4919 1.46518 11.0019 0.985176Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.cec8d3e1c0f182bd0affa36cfcbb5e30.svg";
export { ForwardRef as ReactComponent };